import types from '../types'

const state = {
    model: false,
    text: '',
    color: 'selvyBlue'
}

const mutations = {
    [types.snackBar.mutations.show] (state, { text, color }) {
        state.text = text
        state.color = color
        state.model = true
    },
    [types.snackBar.mutations.disappear] (state) {
        state.model = false
    }
}

const actions = {
    [types.snackBar.actions.show] ({ commit }, { text, color = 'selvyBlue' }) {
        if (text === undefined) {
            throw Error('The "text" parameter must be required on snackBar.')
        }

        commit(types.snackBar.mutations.show, { text, color })
    },
    [types.snackBar.actions.disappear] ({ commit }) {
        commit(types.snackBar.mutations.disappear)
    }
}

const getters = {
    [types.snackBar.getters.model]: state => state.model,
    [types.snackBar.getters.text]: state => state.text,
    [types.snackBar.getters.color]: state => state.color
}

export default {
    state,
    mutations,
    actions,
    getters
}
